module.exports = __webpack_public_path__ + "static/Logo_Junction_Vietnam_horizontal-white-d9329c8eb16ae9376e3a7a9c8307f01d.png";